import { BRAND, BRAND_DARK, BRAND_LIGHT } from "@/shared/constants.js";

export const RadioCard = ({ selected, onClick, title, subtitle, disabled }) => (
  <div onClick={disabled ? undefined : onClick} style={{
    padding: "12px 14px", borderRadius: 10, cursor: disabled ? "default" : "pointer",
    border: `1.5px solid ${selected ? BRAND : "#e0e0de"}`,
    background: selected ? BRAND_LIGHT : "#fff",
    opacity: disabled ? 0.6 : 1,
    transition: "all 0.2s", marginBottom: 8,
  }}>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{
        width: 16, height: 16, borderRadius: "50%",
        border: `2px solid ${selected ? BRAND : "#bbb"}`,
        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
      }}>
        {selected && <div style={{ width: 8, height: 8, borderRadius: "50%", background: BRAND }} />}
      </div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 500, color: selected ? BRAND_DARK : "#333", fontFamily: "'DM Sans', sans-serif" }}>{title}</div>
        {subtitle && <div style={{ fontSize: 11, color: "#888", marginTop: 2, fontFamily: "'DM Sans', sans-serif" }}>{subtitle}</div>}
      </div>
    </div>
  </div>
);
